import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../components/firebase"; // важно: app должен быть экспортирован

const functions = getFunctions(app);

export async function callFn(name, data = {}) {
  const fn = httpsCallable(functions, name);
  const res = await fn(data);
  return res.data;
}

export function makeClientOrderId(prefix = "ord") {
  const rand = Math.random().toString(16).slice(2);
  return `${prefix}_${Date.now()}_${rand}`;
}
